import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcecontrolPermission, IcecontrolSettings, IcepanelSettings, IcepanelsectionSettings, PaymentMethods } from '../../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { expensejournal } from '../../../../icemedx-lib/src/models/accounting/expensejournal';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { otheritemsjournal } from '../../../../icemedx-lib/src/models/accounting/otheritemsjournal';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { servicepaymentreference } from '../../../../icemedx-lib/src/models/accounting/servicepaymentreference';
import { superbillindex } from '../../../../icemedx-lib/src/models/accounting/superbillindex';
import { entity } from '../../../../icemedx-lib/src/models/common/entity';
import { licenseobject } from '../../../../icemedx-lib/src/models/domain/license';
import { orderobject } from '../../../../icemedx-lib/src/models/domain/order';
import { orderdetailobject } from '../../../../icemedx-lib/src/models/domain/orderdetail';
import { payer } from '../../../../icemedx-lib/src/models/domain/payer';
import { paymentrequest } from '../../../../icemedx-lib/src/models/domain/paymentrequest';
import { pharmacy } from '../../../../icemedx-lib/src/models/domain/pharmacy';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { subscriptionobject } from '../../../../icemedx-lib/src/models/domain/subscription';
import { vendor } from '../../../../icemedx-lib/src/models/domain/vendor';
import { diagnosis } from '../../../../icemedx-lib/src/models/ehr/diagnosis';
import { encounterprogressnotes } from '../../../../icemedx-lib/src/models/ehr/encounterprogressnotes';
import { externaldata } from '../../../../icemedx-lib/src/models/ehr/externaldata';
import { orderentryindex } from '../../../../icemedx-lib/src/models/ehr/orderentryindex';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { basecodereference } from '../../../../icemedx-lib/src/models/ehr/subs/basecodereference';
import { diagnosisreference } from '../../../../icemedx-lib/src/models/ehr/subs/diagnosisreference';
import { externaldatareference } from '../../../../icemedx-lib/src/models/ehr/subs/externaldatareference';
import { managementguidelineindex } from '../../../../icemedx-lib/src/models/ehr/subs/managementguidelineindex';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { otheritemsindex } from '../../../../icemedx-lib/src/models/otheritems/otheritemsindex';
import { otheritemsreceiving } from '../../../../icemedx-lib/src/models/otheritems/otheritemsreceiving';
import { logmessage } from '../../../../icemedx-lib/src/models/system/logmessage';
import { LogReport } from '../../../../icemedx-lib/src/models/system/LogReport';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { OrderService } from '../../../../icemedx-lib/src/services/orders/order.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { AppService } from '../app.service';

declare var require: any;
let currentEnv: any = require("../../../../../env.json").currentEnv;

const csBalance = 1;
const csCGL = 2;
const csPayment = 3;
const csSummary = 4;

const DefaultPostingImage: string = "./assets/default_blog_image.png";
const FileUploadClicked: string = "FileUploadClicked";

@Component({
  selector: 'app-outstandingaccountbalance',
  templateUrl: './outstandingaccountbalance.component.html',
  styleUrls: ['./outstandingaccountbalance.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class OutstandingaccountbalanceComponent implements OnInit {
  // Data Members
  serviceCharges: superbillcharges = null;
  chargeList: medicalservice[] = [];
  newCharge: medicalservice = null;
  patientSubscribers: subscriber[] = [];
  pyrCovs: any[] = [];
  responsibleParties: any[] = [];

  // Current Change Members
  currentCharge: any = {};
  currentChargePanel: IcepanelSettings = new IcepanelSettings("", "", "", "", []);
  currentChargeHistory: chargehistory = new chargehistory(null);

  payPost: payment = null;
  totalTax: number = 0.0;
  totalDue: number = 0.0;
  remainingBalance: number = 0.0;
  partyBuckets: any = {};

  // Currency and Currencies
  countries: basecode[] = [];
  currencies: basecode[] = [];
  listOfModifiers: basecode[] = [];

  // NAV Vars
  step: number = csBalance;
  currentCGL: number = 0;

  listOfServices = [];
  listOfInventory = [];

  outStandingBalanceHeader: IcepanelSettings = null;
  outStandingBalanceFormGrp: FormGroup = null;

  billToStatus: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillToStatus", "Status of Service Bucket")
    .setControlName("BillToStatus")
    .createFormControl(0, [Validators.required]);

  diag1Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag1", "Diagnosis 1")
    .setControlName("Diag1")
    .createFormControl("", [Validators.required]);

  diag2Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag2", "Diagnosis 2")
    .setControlName("Diag2")
    .createFormControl("", [Validators.required]);

  diag3Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag3", "Diagnosis 3")
    .setControlName("Diag3")
    .createFormControl("", [Validators.required]);

  diag4Ctrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Diag4", "Diagnosis 4")
    .setControlName("Diag4")
    .createFormControl("", [Validators.required]);

  allDiagnoses: diagnosis[] = [];
  searchSelectedDiags: any[] = []
  allNotes: encounterprogressnotes[] = [];

  apply: IcecontrolSettings = new IcecontrolSettings("icecheckbox", { width: "100%", cursor: 'pointer', label: "Include" }, null, null, "ApplyToBill", "Test")
    .setControlName("ApplyToBill")
    .createFormControl(false, [Validators.required]);

  status: any = {};
  dateFrom: any = {};
  dateTo: any = {};
  itemDesc: any = {};
  note: any = {};
  quantity: any = {};
  unitAmount: any = {};
  totalAmount: any = {};
  amountDue: any = {};
  amountPaid: any = {};
  billTo: any = {};
  unitsInStock: any = {};
  inventoryItemInfo: any = {};
  diagPointers: any = {};
  modifiers: any = {};
  serviceAttachmentTitle: any = {};
  submitServiceAttachment: any = {};
  cancelServiceAttachment: any = {};

  newAttachments: any = {};

  billingsummary: any = {};

  amountSummary: any = {};
  itemSummaryActivity: string = "100";
  itemSummaryModifiers: string = "101";
  itemSummaryDiagnosis: string = "102";
  itemSummaryTaxStatus: string = "103";
  itemSummaryAttachments: string = "104";
  pointerOne: number = 0;
  pointerTwo: number = 1;
  pointerThree: number = 2;
  pointerFour: number = 3;

  addItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Add Item", glyphClass: "fa-plus-circle" }, null, null, "addItem");
  benefitsButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Benefits", glyphClass: "fa-file-alt" }, null, null, "gotoBenefits");

  submitNewItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Submit Item", glyphClass: "fa-plus-circle" }, null, null, "submitItem");

  continueButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Continue", glyphClass: "fa-file-alt" }, null, null, "continueButton");
  doneButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Done" }, null, null, "doneButton");
  backButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Back", glyphClass: "" }, null, null, "backButton");
  printButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Print" }, null, null, "printButton");
  claimsButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Claims" }, null, null, "printButton");

  // Payment:
  paymentCtrl = new IcecontrolSettings("icesubscriptionpayment", {
      menuItems: [],
      width: "475px",
      purchaseCaption: "Account Balance Summary",
      paymentMethods: [PaymentMethods.pmCash],
      subTotal: 0.0,
      otherFees: 0.0,
      grandTotal: 0.0,
      lastErrors: null,
      defaultCountry: "",
      defaultCurrency: ""
    }, null, null, "paymentstatus")
  .setControlName("paymentstatus")
  .createFormControl({}, [Validators.required]);

  constructor(private appSvc: AppService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private ptSvc: PatientService,
    private acctSvc: AccountingService,
    private medCodeSvc: MedicalcodesService,
    private ordSvc: OrderService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Outstanding Account Balance", {}, true, "");

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.billToStatus.setOptions(MessageService.getAccountItemStatues());

    // To do Get Default Currency and Country
    this.activatedRoute.params.subscribe(next => {
      this.acctSvc.getBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), next.key).subscribe(
        data => {
          if (data == null || data.length == 0) return;

          this.serviceCharges = <superbillcharges>data[0];
          if (this.serviceCharges == null) return;
          let headerCtrls = {};
          headerCtrls[this.billToStatus.getControlName()] = this.billToStatus.getFormControl();
          headerCtrls[this.diag1Ctrl.getControlName()] = this.diag1Ctrl.getFormControl();
          headerCtrls[this.diag2Ctrl.getControlName()] = this.diag2Ctrl.getFormControl();
          headerCtrls[this.diag3Ctrl.getControlName()] = this.diag3Ctrl.getFormControl();
          headerCtrls[this.diag4Ctrl.getControlName()] = this.diag4Ctrl.getFormControl();
          //
          this.billToStatus.getFormControl().setValue(Iceutility.toLong(this.serviceCharges.bill_status));
          this.outStandingBalanceFormGrp = new FormGroup(headerCtrls);

          for (let ichrg = 0; ichrg < this.serviceCharges.CHARGES.length; ichrg++) {
            let chrgRef: medicalservicereference = <medicalservicereference>this.serviceCharges.CHARGES[ichrg];

            let foundMedSvc = data.filter(obj => obj.medical_service_key == chrgRef.medical_service_key);
            if (foundMedSvc.length == 0) continue;

            this.addChargeToList(foundMedSvc[0]);
          }

          if (this.isPatient()) {
            this.ptSvc.getProblems(this.serviceCharges.to_trans_account).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                this.allDiagnoses = <diagnosis[]>data;
                let diagOptions = [];
                let pointers = [
                  { name: "", value: -1 },
                  { name: "D1:Unassigned", value: this.pointerOne, code: "" },
                  { name: "D2:Unassigned", value: this.pointerTwo, code: "" },
                  { name: "D3:Unassigned", value: this.pointerThree, code: "" },
                  { name: "D4:Unassigned", value: this.pointerFour, code: "" },
                ];
                // change to use diag.key
                for (let idiag = 0; idiag < data.length; idiag++) {
                  let diag: diagnosis = <diagnosis>data[idiag];
                  if (diag.icd_code == "" || diag.icd_code.length == 0) continue;
                  let icdText = diag.icd_code + " - " + diag.title;

                  diagOptions.push({ value: diag.icd_code, name: icdText });
                }
                this.diag1Ctrl.setOptions(diagOptions);
                this.diag2Ctrl.setOptions(diagOptions);
                this.diag3Ctrl.setOptions(diagOptions);
                this.diag4Ctrl.setOptions(diagOptions);
                this.searchSelectedDiags = this.searchSelectedDiags.concat(diagOptions);

                // change to use diag.key
                if (this.serviceCharges.DIAGS.length >= 1) {
                  let idx = 0;
                  this.updatePointer(idx, pointers, diagOptions, this.serviceCharges.DIAGS);
                  this.diag1Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].icd_code);
                }
                if (this.serviceCharges.DIAGS.length >= 2) {
                  let idx = 1;
                  this.updatePointer(idx, pointers, diagOptions, this.serviceCharges.DIAGS);
                  this.diag2Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].icd_code);
                }
                if (this.serviceCharges.DIAGS.length >= 3) {
                  let idx = 2;
                  this.updatePointer(idx, pointers, diagOptions, this.serviceCharges.DIAGS);
                  this.diag3Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].icd_code);
                }
                if (this.serviceCharges.DIAGS.length >= 4) {
                  let idx = 3;
                  this.updatePointer(idx, pointers, diagOptions, this.serviceCharges.DIAGS);
                  this.diag4Ctrl.getFormControl().setValue(this.serviceCharges.DIAGS[idx].icd_code);
                }

                for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                  let charge: medicalservice = <medicalservice>this.chargeList[ichrg];
                  this.diagPointers[charge.medical_service_key][this.pointerOne].setOptions(pointers);
                  this.diagPointers[charge.medical_service_key][this.pointerTwo].setOptions(pointers);
                  this.diagPointers[charge.medical_service_key][this.pointerThree].setOptions(pointers);
                  this.diagPointers[charge.medical_service_key][this.pointerFour].setOptions(pointers);

                  // Lookup medicalservicereference and set item pointers
                  let fndMREF = this.serviceCharges.CHARGES.filter(x => x.medical_service_key == charge.medical_service_key);
                  if (fndMREF.length > 0) {
                    let mref: medicalservicereference = fndMREF[0];
                    this.setPointer(this.pointerOne, pointers, diagOptions, mref);
                    this.setPointer(this.pointerTwo, pointers, diagOptions, mref);
                    this.setPointer(this.pointerThree, pointers, diagOptions, mref);
                    this.setPointer(this.pointerFour, pointers, diagOptions, mref);
                  }
                }
              },
              error => {
                // To do
              });

            this.ptSvc.getNotesList(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
              "", "", "", "").subscribe(
                data => {
                  if (data == null || data.length == 0) return;
                  this.allNotes = <encounterprogressnotes[]>data;
                },
                error => {
                // To do
                });

            if (this.listOfModifiers.length == 0) {
              this.medCodeSvc.getCodes("MODIFIER_CODE", "", "", "").subscribe(
                data => {
                  if (data && data.length > 0) {
                    this.listOfModifiers = <basecode[]>data;

                    let options = [];
                    for (let imod = 0; imod < this.listOfModifiers.length; imod++) {
                      let bc = this.listOfModifiers[imod];
                      options.push({ value: bc.code, name: bc.code + " - " + bc.title });
                    }
                    options.sort(function (a, b) { return a.name.localeCompare(b.name) });

                    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                      let chrg: medicalservice = <medicalservice>this.chargeList[ichrg];
                      this.modifiers[chrg.medical_service_key].setOptions(options);

                      let mods = [];
                      let modSet = (m) => {
                        if (m != null && m.length > 0) { let t = m; let fndOpt = options.filter(o => o.value == m); if (fndOpt.length > 0) t = fndOpt[0].name; mods.push({ name: t, value: m }); }
                      };
                      modSet(chrg.modifier1);
                      modSet(chrg.modifier2);
                      modSet(chrg.modifier3);
                      modSet(chrg.modifier4);

                      let modCtrl: IcecontrolSettings = this.modifiers[chrg.medical_service_key];
                      modCtrl.getFormControl().setValue(JSON.stringify(mods));
                    }
                  }
                },
                error => {
                  console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
                });
            }

          }

          switch (Iceutility.toLong(this.serviceCharges.from_account_type)) {
            case IceTypes.ACCOUNT_TYPE.actProvider:
            case IceTypes.ACCOUNT_TYPE.actFacility: {
              this.domainSvc.getProvider(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let pro: provider = data[0];
                    this.currencies = pro.CURRENCIES;
                    this.countries = pro.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPharmacy: {
              this.domainSvc.getPharmacy(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let phrm: pharmacy = data[0];
                    this.currencies = phrm.CURRENCIES;
                    this.countries = phrm.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actVendor: {
              this.domainSvc.getVendor(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let ven: vendor = data[0];
                    this.currencies = ven.CURRENCIES;
                    this.countries = ven.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPayer: {
              this.domainSvc.getPayer(this.serviceCharges.from_trans_account).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let pyr: payer = data[0];
                    this.currencies = pyr.CURRENCIES;
                    this.countries = pyr.COUNTRIES;
                  }
                },
                error => {
                  // To do
                }
              );
              break;
            }
            default: {
              break;
            }
          }

          this.remainingBalance = this.totalDue;
        //  this.ctrlBillingDomainType.getFormControl().setValue(Iceutility.toLong(bill.to_account_type));
        //  this.ctrlBillingDomainType.setDisabled(true);

        //  // Set Bill to
        //  this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: bill.to_trans_account, name: bill.bill_to }]));

        //  // Only one should be in bill charges control
        //  let orddesc = Iceutility.isTextDateTime(bill.created) ? Iceutility.getDateTextEx(bill.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(bill.created))
        //    + " - " + bill.superbill_charges_key.substr(0, 10);
        //  this.ctrlBillingDomainOrderCtrl.setOptions([{ value: bill.superbill_charges_key, name: orddesc }]);
        //  let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
        //  frmOrder.setValue(bill.superbill_charges_key);

        //  // Disable order
        //  this.ctrlBillingDomainOrderCtrl.setDisabled(true);
        //  // Load services
        //  this.loadMedicalServices(data);
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        });
    });
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  updatePointer(ptr: number, pointers: any[], doptions: any[], diags: diagnosisreference[]): void {
    if (diags == null || ptr >= diags.length) return;

    // change to use diag.key
    let fnd = doptions.filter(x => x.value == diags[ptr].icd_code);
    if (fnd.length > 0) {
      pointers[ptr + 1].name = "D" + (ptr + 1).toString() + ":" + fnd[0].name;
      pointers[ptr + 1].code = diags[ptr].icd_code;
    }
  }

  setPointer(ptr: number, pointers: any[], doptions: any[],  mref: medicalservicereference): void {
    if (ptr < 0 || ptr > 3) return;
    if (doptions == null || doptions.length == 0) return;
    if (pointers == null || pointers.length < 4) return;
    if (mref == null) return;
    if (mref.DIAGREFS.length >= ptr + 1) {
      // check if pointer in storage matches diag 1 in bucket
      // change to use diag.key
      let fndDIAG = doptions.filter(d => d.value == mref.DIAGREFS[ptr].icd_code);
      let fndPTR = pointers.filter(p => p.code == mref.DIAGREFS[ptr].icd_code);
      if (fndDIAG.length > 0 && fndPTR.length > 0) {
        for (let iFnd = 0; iFnd < fndPTR.length; iFnd++) {
          let thisPtrFound = fndPTR[iFnd].value;
          let ptrCtrl: IcecontrolSettings = this.diagPointers[mref.medical_service_key][thisPtrFound];
          ptrCtrl.getFormControl().setValue(thisPtrFound);
        }
      }
    }
  }

  addChargeToList(charge: medicalservice): void {
    if (charge == null) return;

    this.chargeList.push(charge);

    this.status[charge.medical_service_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "Status" + charge.medical_service_key, "Status of Item")
      .setControlName("Status" + charge.medical_service_key)
      .createFormControl(Iceutility.toLong(charge.trans_status), [Validators.required])
      .setOptions(MessageService.getAccountItemStatues());

    let dtFrom = Iceutility.isTextDateTime(charge.SVCDTS[0].date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].date_required), null, false);
    let dtTo = Iceutility.isTextDateTime(charge.SVCDTS[0].end_date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].end_date_required), null, false);

    this.dateFrom[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, {}, "DateFrom" + charge.medical_service_key)
      .setControlName("DateFrom" + charge.medical_service_key)
      .createFormControl(dtFrom, []);

    this.dateTo[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, {}, "dateTo" + charge.medical_service_key)
      .setControlName("dateTo" + charge.medical_service_key)
      .createFormControl(dtTo, []);

    this.itemDesc[charge.medical_service_key] = new IcecontrolSettings("icetextarea", { width: "100%", height: "100px" }, null, null, "ItemDescription" + charge.medical_service_key, "Service Description")
      .setControlName("ItemDescription" + charge.medical_service_key)
      .createFormControl(charge.service_description, [Validators.required]);

    this.note[charge.medical_service_key] = new IcecontrolSettings("icetextarea", { width: "100%" }, null, null, "AdditionalNote" + charge.medical_service_key, "Note")
      .setControlName("AdditionalNote" + charge.medical_service_key)
      .createFormControl(charge.additional_note, []);

    this.quantity[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, null, "Quantity" + charge.medical_service_key, "Quantity")
      .setControlName("Quantity" + charge.medical_service_key)
      .createFormControl(charge.quantity, []);

    this.unitAmount[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, null, "UnitAmount" + charge.medical_service_key, "Unit Amount")
      .setControlName("UnitAmount" + charge.medical_service_key)
      .createFormControl(charge.price, []);

    this.totalAmount[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%" }, null, null, "TotalAmount" + charge.medical_service_key, "Total Amount")
      .setControlName("TotalAmount" + charge.medical_service_key)
      .createFormControl(charge.total_amount, []);

    this.amountDue[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%", color: "red" }, null, null, "AmountDue" + charge.medical_service_key, "Amount Due")
      .setControlName("AmountDue" + charge.medical_service_key)
      .createFormControl(charge.total_amount/*set this to the total then update below*/, []);

    this.amountPaid[charge.medical_service_key] = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "AmountPaid" + charge.medical_service_key, "Amount to Pay")
      .setControlName("AmountPaid" + charge.medical_service_key)
      .createFormControl(0.0, []);

    let partyBuckey = AccountingService.getPartyBucketKey(charge);
    if (this.partyBuckets[partyBuckey] == null)
      this.partyBuckets[partyBuckey] = { name: "", shortname: "", amount_due: 0.0 };

    if (this.responsibleParties.length == 0) {
      let optForBillTo = this.serviceCharges.bill_to + " (" + DomainService.getDomainType(Iceutility.toLong(this.serviceCharges.to_account_type)) + ", Cash Pay)";
      this.responsibleParties = [{ name: optForBillTo, value: "", summary: [] }];
    }
    this.billTo[charge.medical_service_key] = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillTo" + charge.medical_service_key, "Responsible Party")
      .setControlName("BillTo" + charge.medical_service_key)
      .createFormControl(partyBuckey, [])
      .setOptions(this.responsibleParties);

    this.billingsummary[charge.medical_service_key] = new IcecontrolSettings("icelabel", { width: "100%", height: "100px" }, null, null, "BillingSummary", "Summary")
      .setControlName("BillingSummary" + charge.medical_service_key)
      .createFormControl("", []);

    this.amountSummary[charge.medical_service_key] = new IcecontrolSettings("icebuttongroup", {
      activeButton: this.itemSummaryActivity,
      groupSettings: [
        {
          text: "Activity", value: this.itemSummaryActivity,
          onclick: (event) => {
            if (event.value != null) {
              this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
            }
          }
        },
        {
          text: "Modifiers", value: this.itemSummaryModifiers,
          onclick: (event) => {
            if (event.value != null) {
              this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
            }
          }
        },
        {
          text: "Diagnosis", value: this.itemSummaryDiagnosis,
          onclick: (event) => {
            if (event.value != null) {
              this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
            }
          }
        },
        {
          text: "Tax Status", value: this.itemSummaryTaxStatus,
          onclick: (event) => {
            if (event.value != null) {
              this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
            }
          }
        },
        {
          text: "Attachments", value: this.itemSummaryAttachments,
          onclick: (event) => {
            if (event.value != null) {
              this.amountSummary[charge.medical_service_key].properties.activeButton = event.value;
            }
          }
        }]
    }, null, null, "", "")
      .setControlName("AmountSummary" + charge.medical_service_key);

    this.diagPointers[charge.medical_service_key] = [
      new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillTo_1_" + charge.medical_service_key, "Diagnosis Pointer 1")
        .setControlName("BillTo_1_" + charge.medical_service_key)
        .createFormControl(-1, [])
        .setOptions([]),
      new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillTo_2_" + charge.medical_service_key, "Diagnosis Pointer 2")
        .setControlName("BillTo_2_" + charge.medical_service_key)
        .createFormControl(-1, [])
        .setOptions([]),
      new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillTo_3_" + charge.medical_service_key, "Diagnosis Pointer 3")
        .setControlName("BillTo_3_" + charge.medical_service_key)
        .createFormControl(-1, [])
        .setOptions([]),
      new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "BillTo_4_" + charge.medical_service_key, "Diagnosis Pointer 4")
        .setControlName("BillTo_4_" + charge.medical_service_key)
        .createFormControl(-1, [])
        .setOptions([]),
    ];

    let mods = [];
    let modSet = (m) => { if (m != null && m.length > 0) { mods.push({ name: m, value: m }); } };
    modSet(charge.modifier1);
    modSet(charge.modifier2);
    modSet(charge.modifier3);
    modSet(charge.modifier4);

    this.modifiers[charge.medical_service_key] = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, "Modifiers", "Service Modifiers")
        .setControlName("modifiers_" + charge.medical_service_key)
        .createFormControl(JSON.stringify(mods), [])
        .setMultipleSelection(true)
        .setOptions([]);

    if (charge.unit_code != null && charge.unit_code.length > 0) {
      this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", charge.unit_code, "").subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            //chrgObj.unit_code = data[0].title;
          }
        },
        error => {
          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        });
    }

    if (this.isSupplies(charge)) {
      this.acctSvc.getOtherItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), charge.other_items_key).subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            this.inventoryItemInfo[charge.other_items_key] = data[0];
          }
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        });

      // To do: We should add charge.quantity_confirmed; // which means that its been removed from inventory
      // if confirmed then display "Inventory Confirmed"
      this.acctSvc.getItemReceiving(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), charge.other_items_key).subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            let itemReceiving: otheritemsreceiving[] = data;
            if (this.unitsInStock[charge.other_items_key] == null)
              this.unitsInStock[charge.other_items_key] = 0.0;

            for (let i = 0; i < itemReceiving.length; i++) {
              this.unitsInStock[charge.other_items_key] += Iceutility.toDouble(itemReceiving[i].quantity);
            }
          }
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        }
      );

      this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtInventory, IceTypes.coa_types.coaInventory, "", IceTypes.coa_types.coaInventory).subscribe(
        data => {
          if (data != null) {
            if (this.unitsInStock[charge.other_items_key] == null)
              this.unitsInStock[charge.other_items_key] = 0.0;

            for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
              let jrnl: otheritemsjournal = data[ijrnl];
              let crd = Iceutility.toDouble(jrnl.credit);
              if (charge.other_items_key == jrnl.other_items_key && crd > 0) {
                this.unitsInStock[charge.other_items_key] -= Iceutility.toDouble(jrnl.quantity);
              }
            }
          }
        },
        error => {
          console.log(error);
        });
    }

    if (this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient) {
      if (this.responsibleParties.length <= 1) {
        this.ptSvc.getPatientSubscribers(this.serviceCharges.to_trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
          data => {
            if (data != null && this.responsibleParties.length <= 1) {
              this.patientSubscribers = data;
              let ctrl: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
              for (let isub = 0; isub < data.length; isub++) {
                let sub: subscriber = data[isub];
                if (sub.COVGS.length > 0) {
                  if (this.pyrCovs == null || this.pyrCovs.length == 0)
                    this.pyrCovs = this.ptSvc.getPayerCoverageBenefits(sub, true);

                  if (this.pyrCovs != null) {
                    for (let icov = 0; icov < this.pyrCovs.length; icov++) {
                      let covDtl = this.pyrCovs[icov];
                      this.responsibleParties.push({
                        name: covDtl["payer_name"] + " (Payer)",
                        value: covDtl["payer_id"],
                        summary: covDtl.summary
                      });
                    }
                  }
                }
              }
              ctrl.setOptions(this.responsibleParties);
            }
          },
          error => {
            console.log(error);
          });
      }
      else {
        let ctrl: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
        ctrl.setOptions(this.responsibleParties);
      }
    }

    this.currentChargeHistory.setService(charge.medical_service_key, {});
    this.currentChargeHistory.setServiceAmountDue(charge.medical_service_key, charge["amountDue"]);
    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, charge.medical_service_key, IceTypes.coa_types.coaDeductibleAR).subscribe(
      data => {
        let partyBucketKey = AccountingService.getPartyBucketKey(charge);

        if (data != null) {
          this.currentChargeHistory.setServiceAssets(charge.medical_service_key, data);
          this.currentChargeHistory.setAllServicePostings(charge.medical_service_key, {});
          let credit = 0.0;
          for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
            let jrnl: assetjournal = data[ijrnl];
            let coatyp = Iceutility.toLong(jrnl.coa_type)
            if (coatyp == IceTypes.coa_types.coaAR
              || coatyp == IceTypes.coa_types.coaCoPayAR
              || coatyp == IceTypes.coa_types.coaCoInsuranceAR
              || coatyp == IceTypes.coa_types.coaDeductibleAR)
              credit += Iceutility.toDouble(jrnl.credit);

            let thisPostnig = this.currentChargeHistory.getServicePosting(charge.medical_service_key, jrnl.src_key);
            let srctype = Iceutility.toLong(jrnl.src_type);
            if (srctype == IceTypes.SourceType.srcPayment
              && thisPostnig == null) {
              this.acctSvc.getPayment(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), jrnl.src_key).subscribe(
                paydata => {
                  if (paydata != null && paydata.length > 0) {
                    if (thisPostnig == null) {
                      this.currentChargeHistory.setServicePosting(charge.medical_service_key, jrnl.src_key, paydata[0]);
                    }
                  }
                },
                payerror => {
                  console.log(payerror);
                });
            }
          }
          let ctrl: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
          let frmCtrl = ctrl.getFormControl();
          frmCtrl.setValue(frmCtrl.value - credit);
          ctrl.properties.color = frmCtrl.value > 0 ? "red" : "green";

          this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(frmCtrl.value);
          this.totalDue += Iceutility.toDouble(frmCtrl.value);
          this.currentChargeHistory.setServiceAmountDue(charge.medical_service_key, charge["amountDue"]);
        }
        else {
          this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(charge.total_amount);
          this.totalDue += Iceutility.toDouble(charge.total_amount);
        }
      },
      error => {
        console.log(error);
      });

    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtExpense, IceTypes.coa_types.coaDiscount, charge.medical_service_key, IceTypes.coa_types.coaCorrectionandReversalsAdjustment).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceExpenses(charge.medical_service_key, data);
        }
      },
      error => {
        console.log(error);
      });

    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtIncome, IceTypes.coa_types.coaRevenue, charge.medical_service_key, IceTypes.coa_types.coaCoInsuranceIncome).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceIncomes(charge.medical_service_key, data);
        }
      },
      error => {
        console.log(error);
      });
  }

  getOutStandingBalanceHeaderGroup(): FormGroup {
    return this.outStandingBalanceFormGrp;
  }

  isPatient(): boolean {
    return this.serviceCharges != null && this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient;
  }

  getPatientAccount(): string {
    if (this.serviceCharges != null && this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient)
      return this.serviceCharges.to_trans_account;

    return "";
  }

  isSupplies(charge: medicalservice): boolean {
    return charge != null && Iceutility.toBoolean(charge.service_option) == false;
  }

  getServiceOptionText(charge: medicalservice): string {
    if (charge == null) return "";

    let ret = "Service";
    if (charge.inc_coa_type == IceTypes.coa_types.coaOtherIncome) {
      ret = !this.isSupplies(charge) ? "Service" : "Supplies";
    }
    else if (charge.inc_coa_type == IceTypes.coa_types.coaCoPayIncome) {
      ret = "Co-Payment"
    }

    return ret;
  }

  getAmountToBill(charge: medicalservice): string {
    if (charge == null) return "";

    let ret = "0.0";
    let ctrlAmtDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
    let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[charge.medical_service_key];
    let frmCtrlDue = ctrlAmtDue.getFormControl();
    let frmCtrlPaid = ctrlPaid.getFormControl();
    if (frmCtrlPaid && frmCtrlDue) {
      let amtDue = frmCtrlDue.value;
      let amtPaid = frmCtrlPaid.value;
      ret = (Iceutility.toDouble(amtDue) - Iceutility.toDouble(amtPaid)).toString();
    }
    return ret;
  }

  getPayHistory(charge: medicalservice, newPostOnly: boolean = false): string {
    let ret = "0.0";
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      let total = 0.0;
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        if (newPostOnly && thispost.offline_record_status != IceTypes.offlineRecStatus.offlineInsert) {
          continue;
        }
      
        for (let isvc = 0; isvc < thispost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = thispost.SERVICES[isvc];
          if (svcref != null && 
            (IceTypes.coa_types.coaAR == svcref.coa_type
            || IceTypes.coa_types.coaCoInsuranceAR == svcref.coa_type
            || IceTypes.coa_types.coaDeductibleAR == svcref.coa_type)) {
            total += Iceutility.toDouble(svcref.amount);
          }
        }
      }
      ret = Iceutility.toDouble(total).toString();
    }
    return ret;
  }

  getAdjustmentHistory(charge: medicalservice): string {
    let ret = "0.0";
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      let total = 0.0;
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        for (let isvc = 0; isvc < thispost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = thispost.SERVICES[isvc];
          if (svcref != null &&
            (IceTypes.coa_types.coaClaimAdjustment == svcref.coa_type
            || IceTypes.coa_types.coaDisallowedAdjustment == svcref.coa_type
            || IceTypes.coa_types.coaContractualObligationsAdjustment == svcref.coa_type
            || IceTypes.coa_types.coaCorrectionandReversalsAdjustment == svcref.coa_type)) {
            total += Iceutility.toDouble(svcref.amount);
          }
        }
      }
      ret = Iceutility.toDouble(total).toString();
    }
    return ret;
  }

  getDiscountHistory(charge: medicalservice): string {
    let ret = "0.0";
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      let total = 0.0;
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        for (let isvc = 0; isvc < thispost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = thispost.SERVICES[isvc];
          if (svcref != null &&
            (IceTypes.coa_types.coaDiscount == svcref.coa_type)) {
            total += Iceutility.toDouble(svcref.amount);
          }
        }
      }
      ret = Iceutility.toDouble(total).toString();
    }
    return ret;
  }

  getNewPostings(charge: medicalservice): payment[] {
    let ret: payment[] = null;
    let postdata = this.currentChargeHistory.getAllServicePostings(charge.medical_service_key);
    if (postdata != null) {
      for (const postkey in postdata) {
        let thispost: payment = postdata[postkey];
        if (thispost == null) continue;

        if (thispost.offline_record_status != IceTypes.offlineRecStatus.offlineInsert) {
          continue;
        }
        if (ret == null)
          ret = [];

        ret.push(thispost);
      }
    }
    return ret;
  }

  getItemSummaryActiveButton(charge: medicalservice): string {
    if (charge == null || this.amountSummary[charge.medical_service_key] == null
      || this.amountSummary[charge.medical_service_key].properties == null) return "";

    return this.amountSummary[charge.medical_service_key].properties.activeButton;
  }

  getTotalTax(): string {
    return this.totalTax.toString();
  }

  getTotalDue(): string {
    return this.totalDue.toString();
  }

  getTotalPaidAmount(): string {
    if (this.payPost == null) return "0";
    return this.payPost.total_paid.toString();
  }

  getRemainingBalance(): string {
    let ret = 0.0;
    let paid = 0.0;
    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let chrg = this.chargeList[ichrg];
      let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[chrg.medical_service_key];
      let frmCtrlPaid = ctrlPaid.getFormControl();
      if (frmCtrlPaid) {
        paid += Iceutility.toDouble(frmCtrlPaid.value);
      }
    }
    if (this.payPost != null) this.payPost.total_paid = paid;
    this.remainingBalance = this.totalDue - paid;
    return this.remainingBalance.toString();
  }

  getPartyBuckets(): any[] {
    let ret = Object.keys(this.partyBuckets).map((key) => {
      if (this.partyBuckets[key].name == null || this.partyBuckets[key].name.length == 0) {
        if (this.pyrCovs != null && this.pyrCovs.length > 0) {
          let covFound = this.pyrCovs.filter(c => c.payer_id == key);
          if (covFound.length > 0) {
            this.partyBuckets[key].name = covFound[0].payer_name;            
          }
          else if (key == null || key.length == 0) {
            this.partyBuckets[key].name = this.serviceCharges.bill_to;
          }

          let parts = this.partyBuckets[key].name.split(" ");
          let shortname = "";
          for (let i = 0; i < parts.length; i++) {
            let part: string = parts[i];
            if (part.length == 0 || part.substring(0, 1) == "(") continue;
            shortname += part.substring(0, 1);
          }
          this.partyBuckets[key].shortname = shortname;
        }
      }
      return {
        partykey: key,
        name: this.partyBuckets[key].name,
        shortname: this.partyBuckets[key].shortname,
        amount_due: this.partyBuckets[key].amount_due
      }
    });
    return ret;
  }

  getCurrency(): string {
    return this.currencies.length > 0 ? this.currencies[0].code : "USD";
  }

  getEditServiceClass(chge: medicalservice): any {
    return { "fas": true, "fa-edit": true, "fa-2x": true };
  }

  getAttachmentUrl(extData: externaldata): string {
    if (extData == null || false == Iceutility.isdefined(extData["_postImageUrl"])) return DefaultPostingImage;

    return extData["_postImageUrl"];
  }

  getNewAttachments(chge: medicalservice): externaldata[] {
    if (this.newAttachments[chge.medical_service_key] == null)
      this.newAttachments[chge.medical_service_key] = [];
    return <externaldata[]>this.newAttachments[chge.medical_service_key];
  }

  getNewAttachmentUrl(extData: externaldata): string {
    return DefaultPostingImage;
  }

  getNewAttachmentType(extData: externaldata): string {
    if (extData["tempFile"] == null) return "";
    return extData["tempFile"]["type"];
  }

  getNewAttachmentSize(extData: externaldata): string {
    if (extData["tempFile"] == null) return "";
    return extData["tempFile"]["size"];
  }

  getNewAttachmentStatus(extData: externaldata): string {
    return "Copying";
  }

  showNewAttachmentButtons(chge: medicalservice): boolean {
    return this.newAttachments[chge.medical_service_key] != null && this.newAttachments[chge.medical_service_key].length > 0;
  }

  initializePartyBuckets(defPartyBucket: string, ctrl: IcecontrolSettings): void {
    let testinitial = Object.keys(this.partyBuckets).map((key) => {
      this.partyBuckets[key].amount_due = 0.0;
      return this.partyBuckets[key];
    });

    if (ctrl == null) return;

    if (defPartyBucket != null) {
      let optFound = ctrl.getOptions().filter(o => o.value == defPartyBucket);
      if (this.partyBuckets[defPartyBucket] == null) {
        if (optFound.length > 0)
          this.partyBuckets[defPartyBucket] = { name: "", shortname: "", amount_due: 0.0 };
      }

      let summaryCtrl: IcecontrolSettings = <IcecontrolSettings>this.billingsummary[ctrl.id.replace("BillTo", "")];
      if (summaryCtrl != null) {
        summaryCtrl.getFormControl().setValue("");
        if (optFound.length > 0) {
          summaryCtrl.getFormControl().setValue(optFound[0].summary.join("<br>"));
        }
      }
    }
  }

  submitServiceAttachmentsClick(event: any, chge: medicalservice) {
    debugger;
    //loop and submit
    //var fd = new FormData();
    //fd.append('icefile', extData["tempFile"]);
  }

  cancelServiceAttachmentsClick(event: any, chge: medicalservice) {
    for (let ifile = 0; ifile < chge.EDOCS.length; ifile++) {
      let extData = chge.EDOCS[ifile];
      extData["tempFile"] = null;
      delete extData["tempFile"];
    }
    chge.EDOCS = [];
    this.newAttachments[chge.medical_service_key] = [];
  }

  onAttachImageSelect(event: any, chge: medicalservice) {
    debugger;
    if (event && event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      let fil: File = event.target.files[0];
      reader.onload = (event) => {
        let usrInfo = this.loginSvc.GetSessionUserInfo();

        // create doc file
        let extData: externaldata = new externaldata();
        extData.external_data_key = Iceutility.guid();
        extData.original_path = fil["name"];
        extData["tempFile"] = fil;

        if (this.newAttachments[chge.medical_service_key] == null)
          this.newAttachments[chge.medical_service_key] = [];

        this.newAttachments[chge.medical_service_key].push(extData);

        // create ref  
        let extDataRef: externaldatareference = new externaldatareference();
        extDataRef.external_data_key = extData.external_data_key;
        chge.EDOCS.push(extDataRef);

        if (this.serviceAttachmentTitle[chge.medical_service_key] == null)
          this.serviceAttachmentTitle[chge.medical_service_key] = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "serviceAttachmentTitle_" + chge.medical_service_key, "Title of Attachment")
            .setControlName("serviceAttachmentTitle_" + chge.medical_service_key)
            .createFormControl("", []);

        if (this.submitServiceAttachment[chge.medical_service_key] == null)
          this.submitServiceAttachment[chge.medical_service_key] = new IcecontrolSettings("icebutton", { width: "50px", text: "Submit" }, null, null, "submitServiceAttachment_" + chge.medical_service_key);

        if (this.cancelServiceAttachment[chge.medical_service_key] == null)
          this.cancelServiceAttachment[chge.medical_service_key] = new IcecontrolSettings("icebutton", { width: "50px", text: "Cancel" }, null, null, "submitServiceAttachment_" + chge.medical_service_key);
      };

      reader.onprogress = (event) => {
        debugger;
      };

      reader.onloadend = (event) => {
        debugger;
      };
      reader.readAsDataURL(event.target.files[0]); // read file as data url
    }
  }

  editService(event, chge: medicalservice): void {
    if (chge == null) return;

    this.currentCharge[chge.medical_service_key] = chge;
    this.initializeCurrentChargePanel(event);
  }

  billToSelectChange(event): void {
    let thisPartyBucketKey = event.value;

    this.initializePartyBuckets(thisPartyBucketKey, <IcecontrolSettings>event.selectSettings);

    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let charge = this.chargeList[ichrg];
      let partyBucketKey = "";
      let ctrlBillItemTo: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
      if (ctrlBillItemTo != null) {
        partyBucketKey = ctrlBillItemTo.getFormControl().value;
      }
      if (this.partyBuckets[partyBucketKey] == null) continue;

      let ctrlDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
      let frmCtrlDue = ctrlDue.getFormControl();
      if (frmCtrlDue) {
        this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(frmCtrlDue.value);
      }
    }
  }

  diagChange(event) {
    debugger;
    let ctrl: IcecontrolSettings = event.selectSettings;
    if (ctrl == null) return;

    let diagOptions = ctrl.getOptions();
    // change to use diag.key
    switch (ctrl.id) {
      case "Diag1": this.serviceCharges.DIAGS[0].icd_code = event.value; break;
      case "Diag2": this.serviceCharges.DIAGS[1].icd_code = event.value; break;
      case "Diag3": this.serviceCharges.DIAGS[2].icd_code = event.value; break;
      case "Diag4": this.serviceCharges.DIAGS[3].icd_code = event.value; break;
    }

    let code = event.value;
    for (let svc = 0; svc < this.serviceCharges.CHARGES.length; svc++) {
      let mref = this.serviceCharges.CHARGES[svc];

      // reset these pointers
      let pointers = [
        { name: "", value: -1 },
        { name: "D1:Unassigned", value: this.pointerOne, code: "" },
        { name: "D2:Unassigned", value: this.pointerTwo, code: "" },
        { name: "D3:Unassigned", value: this.pointerThree, code: "" },
        { name: "D4:Unassigned", value: this.pointerFour, code: "" },
      ];
      this.diagPointers[mref.medical_service_key][this.pointerOne].setOptions(pointers);
      this.diagPointers[mref.medical_service_key][this.pointerTwo].setOptions(pointers);
      this.diagPointers[mref.medical_service_key][this.pointerThree].setOptions(pointers);
      this.diagPointers[mref.medical_service_key][this.pointerFour].setOptions(pointers);

      // update pointer option 
      this.updatePointer(this.pointerOne, pointers, diagOptions, this.serviceCharges.DIAGS);
      this.updatePointer(this.pointerTwo, pointers, diagOptions, this.serviceCharges.DIAGS);
      this.updatePointer(this.pointerThree, pointers, diagOptions, this.serviceCharges.DIAGS);
      this.updatePointer(this.pointerFour, pointers, diagOptions, this.serviceCharges.DIAGS);

      // set the pointer selected
      this.setPointer(this.pointerOne, pointers, diagOptions, mref);
      this.setPointer(this.pointerTwo, pointers, diagOptions, mref);
      this.setPointer(this.pointerThree, pointers, diagOptions, mref);
      this.setPointer(this.pointerFour, pointers, diagOptions, mref);
    }
  }

  onProblemListUpdate(event): void {
    debugger;
    if (event == null || event.length == 0) return;

    let diag: diagnosis = <diagnosis>event[0];
    let diagOptions = this.diag4Ctrl.getOptions();
    // change to use diag.key
    let fndOpt = diagOptions.filter(o => o.value == diag.icd_code);
    if (fndOpt.length > 0) {
      let icdText = diag.icd_code + " - " + diag.title;
      fndOpt[0].name = icdText;
    }

    this.diag1Ctrl.setOptions(diagOptions);
    this.diag2Ctrl.setOptions(diagOptions);
    this.diag3Ctrl.setOptions(diagOptions);
    this.diag4Ctrl.setOptions(diagOptions);

    for (let svc = 0; svc < this.serviceCharges.CHARGES.length; svc++) {
      let mref = this.serviceCharges.CHARGES[svc];

      // reset these pointers
      let pointers = this.diagPointers[mref.medical_service_key][this.pointerOne].getOptions();

      // update pointer option 
      this.updatePointer(this.pointerOne, pointers, diagOptions, this.serviceCharges.DIAGS);
      this.updatePointer(this.pointerTwo, pointers, diagOptions, this.serviceCharges.DIAGS);
      this.updatePointer(this.pointerThree, pointers, diagOptions, this.serviceCharges.DIAGS);
      this.updatePointer(this.pointerFour, pointers, diagOptions, this.serviceCharges.DIAGS);
    }
  }

  addItemClick(event): void {
    this.newCharge = new medicalservice();
    this.newCharge.inc_coa_type = IceTypes.coa_types.coaServiceIncome;
    if (this.listOfServices.length == 0) {
      this.acctSvc.getBillTemplates(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.serviceCharges.to_account_type, "").subscribe(
        billTemplates => {
          if (billTemplates == null || billTemplates.length == 0) {
            return;
          }

          for (let i = 0; i < billTemplates.length; i++) {
            let tempidx: superbillindex = billTemplates[i];
            if (tempidx == null) continue;

            this.acctSvc.getBillTemplate(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), tempidx.superbill_key).subscribe(
              superbillData => {
                if (superbillData && superbillData.length > 0) {
                  let superbill = superbillData[0],
                    subtypes = superbill.SUBTYPES;

                  for (var isubtype = 0; isubtype < subtypes.length; isubtype++) {
                    let subtype = subtypes[isubtype];
                    if (subtype == null) continue;

                    let srcMapKey = subtype.src_type,
                      codes = subtype.CODES;

                    for (var icode = 0; icode < codes.length; icode++) {
                      let code: basecodereference = codes[icode];
                      if (code == null) continue;

                      let obj = {
                        value: code.code,
                        name: code.title,
                        code: code.code,
                        price: code.price,
                      };
                      this.listOfServices.push(obj);
                    }
                  }
                }
              },
              error => {
                console.log(JSON.stringify(this.acctSvc.getLastErrors()));
              });
          }
        }, error => {
          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        });
    }

    if (this.listOfInventory.length == 0) {
      this.acctSvc.getOtherItems(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "*" /*all*/).subscribe(
        data => {
          if (data == null || data.length == 0) {
            return;
          }
          for (let iresult = 0; iresult < data.length; iresult++) {
            let item: otheritemsindex = data[iresult];

            let obj = {
              value: item.item_stock_num,
              name: item.itm_name,
              code: item.item_stock_num,
              price: item.price,
              key: item.other_items_key
            };
            this.listOfInventory.push(obj);
          }
        },
        error => {
          // To do, log error
        });
    }
  }

  initializeCurrentChargePanel(event: any) {
    setTimeout(() => {
      if (this.currentChargePanel != null) {
        if (this.currentChargePanel.getInitializeEvent() != null) {
          this.currentChargePanel.getInitializeEvent().emit(event);
        }
      }
    });
  }

  onAddItemDoneClick(event): void {
    // to do add item
    this.newCharge.trans_account = this.serviceCharges.to_trans_account;
    this.newCharge.account_type = this.serviceCharges.to_account_type;
    this.acctSvc.insertServices(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.newCharge).subscribe(
      data => {
        if (data != null && data.length > 0) {
          let newSvc: medicalservice = data[0];
          this.addChargeToList(newSvc);

          let chrgRef: medicalservicereference = new medicalservicereference();
          chrgRef.medical_service_reference_key = Iceutility.guid(true);
          chrgRef.medical_service_key = newSvc.medical_service_key;
          this.serviceCharges.CHARGES.push(chrgRef);
          this.acctSvc.updateBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.serviceCharges).subscribe(
            data => {
            },
            error => {
              console.log(error);
            });
        }
      },
      error => {
        console.log(error);
      });

    this.newCharge = null;
  }

  onAddItemCancelClick(event): void {
    this.newCharge = null;
  }

  onItemDoneClick(event, chge: medicalservice): void {
    let curDom = this.appSvc.getCurrentAccount();
    let curDomType = this.appSvc.getCurrentAccountType();
    this.currentCharge[chge.medical_service_key] = null;
  }

  onItemCancelClick(event, chge: medicalservice): void {
    this.currentCharge[chge.medical_service_key] = null;
  }

  benefitsClick(event): void {
    // To do let's only do this for provider when patient has payer/coverage, also open the provider and patient below redirected 
    let url = this.navSvc.buildRoute("PHR/ListOfBenefits?domain=" + this.serviceCharges.to_trans_account, true);
    if (currentEnv == "local")
      location.href = url;
    else
      window.open(url, "_blank");
  }

  submitItemClick(event): void {

  }

  doneClick(event): void {
    this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
  }

  continueClick(event): void {
    // Reset outstanding globals
    this.totalDue = 0.0;
    this.totalTax = 0.0;
    this.payPost = null;

    this.serviceCharges.bill_status = this.billToStatus.getFormControl().value;
    if (this.isPatient()) {
      // change to use diag.key
      if (this.serviceCharges.DIAGS.length >= 1) {
        this.serviceCharges.DIAGS[0].icd_code = this.diag1Ctrl.getFormControl().value;
      }
      else {
        let diagRef = new diagnosisreference();
        diagRef.icd_code = this.diag1Ctrl.getFormControl().value;
        this.serviceCharges.DIAGS.push(diagRef);
      }

      if (this.serviceCharges.DIAGS.length >= 2) {
        this.serviceCharges.DIAGS[1].icd_code = this.diag2Ctrl.getFormControl().value;
      }
      else {
        let diagRef = new diagnosisreference();
        diagRef.icd_code = this.diag2Ctrl.getFormControl().value;
        this.serviceCharges.DIAGS.push(diagRef);
      }

      if (this.serviceCharges.DIAGS.length >= 3) {
        this.serviceCharges.DIAGS[2].icd_code = this.diag3Ctrl.getFormControl().value;
      }
      else {
        let diagRef = new diagnosisreference();
        diagRef.icd_code = this.diag3Ctrl.getFormControl().value;
        this.serviceCharges.DIAGS.push(diagRef);
      }

      if (this.serviceCharges.DIAGS.length >= 4) {
        this.serviceCharges.DIAGS[3].icd_code = this.diag4Ctrl.getFormControl().value;
      }
      else {
        let diagRef = new diagnosisreference();
        diagRef.icd_code = this.diag4Ctrl.getFormControl().value;
        this.serviceCharges.DIAGS.push(diagRef);
      }
    }

    
    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let charge = this.chargeList[ichrg];

      let ctrlStatus: IcecontrolSettings = <IcecontrolSettings>this.status[charge.medical_service_key];
      if (ctrlStatus == null) continue;
      let frmCtrlStatus = ctrlStatus.getFormControl();
      if (frmCtrlStatus == null) continue;
      charge.trans_status = frmCtrlStatus.value;

      let ctrlDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
      let frmCtrlDue = ctrlDue.getFormControl();
      if (frmCtrlDue) {
        this.totalDue += Iceutility.toDouble(frmCtrlDue.value);
      }

      let ctrlItemDesc: IcecontrolSettings = <IcecontrolSettings>this.itemDesc[charge.medical_service_key];
      if (ctrlItemDesc == null) continue;

      if (ctrlItemDesc.getFormControl().dirty) {
        charge.service_description = ctrlItemDesc.getFormControl().value;
      }

      let ctrlNote: IcecontrolSettings = <IcecontrolSettings>this.note[charge.medical_service_key];
      if (ctrlNote != null) {
        charge.additional_note = ctrlNote.getFormControl().value;
      }

      let ctrlBillItemTo: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
      if (ctrlBillItemTo != null) {
        AccountingService.setServiceSubscriberFromDDLKey(ctrlBillItemTo, charge);
      }

      charge.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;

      // get diag pointers
      if (this.isPatient()) {
        debugger;
        let ptr0: IcecontrolSettings = this.diagPointers[charge.medical_service_key][this.pointerOne];
        let ptr1: IcecontrolSettings = this.diagPointers[charge.medical_service_key][this.pointerTwo];
        let ptr2: IcecontrolSettings = this.diagPointers[charge.medical_service_key][this.pointerThree];
        let ptr3: IcecontrolSettings = this.diagPointers[charge.medical_service_key][this.pointerFour];

        let fndMREF = this.serviceCharges.CHARGES.filter(x => x.medical_service_key == charge.medical_service_key);
        if (fndMREF.length > 0) {
          let mref: medicalservicereference = fndMREF[0];
          mref.DIAGREFS = [];
          let ptr = ptr0.getFormControl().value;
          if (ptr >= 0) {mref.DIAGREFS.push(this.serviceCharges.DIAGS[ptr]);}
          ptr = ptr1.getFormControl().value;
          if (ptr >= 0) { mref.DIAGREFS.push(this.serviceCharges.DIAGS[ptr]); }
          ptr = ptr2.getFormControl().value;
          if (ptr >= 0) { mref.DIAGREFS.push(this.serviceCharges.DIAGS[ptr]); }
          ptr = ptr3.getFormControl().value;
          if (ptr >= 0) { mref.DIAGREFS.push(this.serviceCharges.DIAGS[ptr]); }
        }

        try {
          let modCtrl: IcecontrolSettings = this.modifiers[charge.medical_service_key];
          let modObjs = JSON.parse(modCtrl.getFormControl().value);
          if (modObjs != null) {
            for (let imod = 0; imod < modObjs.length; imod++) {
              let mod = modObjs[imod];
              switch (imod) {
                case 0:
                  charge.modifier1 = mod.value;
                  break;
                case 1:
                  charge.modifier2 = mod.value;
                  break;
                case 2:
                  charge.modifier3 = mod.value;
                  break;
                case 3:
                  charge.modifier4 = mod.value;
                  break;
              }
            }
          }
        }
        catch (e) {

        }
      }

      let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[charge.medical_service_key];
      let frmCtrlPaid = ctrlPaid.getFormControl();
      if (frmCtrlPaid) {
        // Create payment object and keep in memory until
        let postDate = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
        let refNum = "";
        let svcKey = charge.medical_service_key;
        let amtPaid = frmCtrlPaid.value;

        let postings = this.getNewPostings(charge);
        if (amtPaid == 0.0 && postings == null) {
          switch (frmCtrlStatus.value) {
            case IceTypes.trans_status.isReadyToPrint:
            case IceTypes.trans_status.isReadyToSend: {
              // pass through
              break;
            }
            default:
              continue;
          }
        }

        if (this.payPost == null) {
          this.payPost = new payment();
          this.payPost.trans_account = this.serviceCharges.to_trans_account;
          this.payPost.account_type = this.serviceCharges.to_account_type;
          this.payPost.billed_to = this.serviceCharges.bill_to;
          this.payPost.pay_date = postDate;
        }
        else {
          // we may want to reset all svc pay refs here
        }

        if (amtPaid > 0.0) { // add the default amt paid to the payment to post
          let svcref: servicepaymentreference = null;
          // to do remove this as it could now cause a overwrite of a service pay ref record 
          let foundOrdSvc = this.payPost.SERVICES.filter(s => s.medical_service_key == svcKey);
          if (foundOrdSvc.length == 0) {
            svcref = new servicepaymentreference();
            svcref.service_reference_key = Iceutility.guid(true);
            svcref.medical_service_key = svcKey;
            this.payPost.SERVICES.push(svcref);
          }
          else {
            svcref = foundOrdSvc[0];
          }
          svcref.description = charge.service_description;
          svcref.subscriber_key = charge.subscriber_key;
          svcref.coverage_key = charge.coverage_key;
          svcref.payer_key = charge.payer_key;
          svcref.amount = amtPaid;
          svcref.coa_type = charge.inc_coa_type == IceTypes.coa_types.coaCoPayIncome ? IceTypes.coa_types.coaCoPayAR : IceTypes.coa_types.coaAR;
        }
        // iterate postings and collect the service pay ref's to the payment to post
        for (let ipy = 0; postings != null && ipy < postings.length; ipy++) {
          let pypost = postings[ipy];
          for (let isvcref = 0; isvcref < pypost.SERVICES.length; isvcref++) {
            let svcref = pypost.SERVICES[isvcref];
            this.payPost.SERVICES.push(svcref);
          }
        }
      }
    }

    // Update services now
    this.acctSvc.updateServices(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.chargeList).subscribe(
      svcData => {
          // Do this for done, continue and pay now
          this.acctSvc.updateBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.serviceCharges).subscribe(
            data => {
              if (this.chargeList.length > 0) {
                if (this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient) {
                  this.step = csCGL;
                }
                else {
                  if (this.payPost == null || this.payPost.SERVICES.length == 0) {
                    this.step = csSummary;
                  }
                  else {
                    this.initializePaymentControl();
                    this.step = csPayment;
                  }
                }
                this.currentCGL = 0;
              }
            },
            error => {
              console.log(error);
            });
      },
      error => {
        console.log(error);
      });

  }

  // Search current payment posting and collect them into one payment based on reference_num, cash_coa_type, and paytype (CC/ACH/CASH)
  checkForPayNewPaymentPostings(): payment {
    return null;
  }

  initializePaymentControl(): void {
    if (this.currencies.length > 0 && (this.currencies[0]["rate"] == "0" || this.currencies[0]["rate"] === 0)) {
      this.currencies[0]["rate"] = 1;
    }

    if (this.currencies.length > 0)
      this.paymentCtrl.properties.defaultCountry = this.countries[0].code;
    else
      this.paymentCtrl.properties.defaultCountry = "USA";

    if (this.currencies.length > 0)
      this.paymentCtrl.properties.defaultCurrency = this.currencies[0].code;
    else
      this.paymentCtrl.properties.defaultCurrency = "USD";

    try {


      let opts = [];
      if (this.payPost != null) {
        for (let isvc = 0; isvc < this.payPost.SERVICES.length; isvc++) {
          let svcref: servicepaymentreference = this.payPost.SERVICES[isvc];
          if (svcref == null) continue;

          let licObj: licenseobject = new licenseobject();
          if (licObj == null) continue;
          licObj.license_id = 1;
          licObj.title = svcref.description;
          licObj.rate = svcref.amount;

          let sub: subscriptionobject = <subscriptionobject>licObj;
          sub.subscription_key = svcref.medical_service_key;
          if (this.currencies.length > 0)
            sub.CURRENCIES.push(this.currencies[0]);
          if (this.countries.length > 0)
            sub.COUNTRIES.push(this.countries[0]);

          // lic condition
          if (Iceutility.toBoolean(licObj.disabled)) continue;

          //if (licObj.account_type == this.appSvc.getCurrentAccountType()) {
          //// filter out countries
          //if (false == this.getDomainService().supportedLicenseCountry(licObj, countries)) {
          //  continue;
          //}

          //// filter out currencies
          //if (false == this.getDomainService().supportedLicenseCurrency(licObj, currencies)) {
          //  continue;
          //}
          // set default lics defaultLics
          //}
          licObj["temp_image"] = "./assets/default_blog_image.png";
          opts.push(licObj);
        }
      }
      this.paymentCtrl.setOptions(opts);

      //if (opts.length > 0) {
      //  // append title caption with  "Click to Buy =>"
      //  this.subTable.showAddButton(true);
      //}
      //else {
      //  this.getDomainService().logMessage(IceTypes.LOGTYPE.ltWarning, "You will need to set your default country and currency to purchase subscriptions.");
      //}

      // Set Totals
      // To do if any items are licObj.license_id == 1 is checked then we should set subTotal and grandTotal
      this.paymentCtrl.properties.subTotal = 0.0;
      this.paymentCtrl.properties.otherFees = 0.0;
      this.paymentCtrl.properties.grandTotal = 0.0;
      this.paymentCtrl.properties.lastErrors = null;
    }
    catch (e) {
      console.log(e);
    }
  }

  continueFromCGLClick(event): void {
    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
      let charge = this.chargeList[ichrg];

      if (charge.offline_record_status != IceTypes.offlineRecStatus.offlineNoChange) {
        // Update services again
        this.acctSvc.updateServices(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), [charge]).subscribe(
          data => {
            if (data != null) {
              charge.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
            }
          },
          error => {
            console.log(error);
          });
      }
    }

    debugger;
    if (this.payPost != null && this.payPost.SERVICES.length > 0) {
      this.initializePaymentControl();
      this.step = csPayment;
      this.currentCGL = 0;
    }
    else {
      this.step = csSummary;
      this.currentCGL = 0;
      //this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
    }
  }

  backFromCGLClick(event): void {
    this.step = csBalance;
    this.currentCGL = 0;
  }

  doneFromCGLClick(event): void {
    this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
  }

  backClick(event): void {
    if (this.step == csSummary) {
      this.step = csCGL;
    }
    else {
      this.step--;
    }
     
    this.currentCGL = 0;
  }

  printClick(event): void {

  }

  claimsClick(event): void {

  }

  paymentChange(event): void {
    switch (event.buttonSettings.id) {
      case "paymentstatus": {
        let paymentCtrl: IcecontrolSettings = event.buttonSettings;

        switch (event.buttonAction) {
          case "OptionChange": {
            paymentCtrl.properties.subTotal = 0.0;
            paymentCtrl.properties.otherFees = 0.0;
            paymentCtrl.properties.grandTotal = 0.0;
            paymentCtrl.properties.lastErrors = null;

            let opts: licenseobject[] = paymentCtrl.getOptions();
            for (let iLic = 0; iLic < opts.length; iLic++) {
              let licObj: licenseobject = opts[iLic];
              if (licObj == null) continue;

              // lic condition
              if (licObj.license_id == 1) {
                // filter out licObj.COUNTRIES
                paymentCtrl.properties.subTotal += Iceutility.toDouble(licObj.rate);
              }
            }

            // Set Total
            paymentCtrl.properties.grandTotal = Iceutility.toDouble(paymentCtrl.properties.otherFees) + paymentCtrl.properties.subTotal;
            break;
          }
        }
        break;
      }
    }
  }

  processOrCancelPayment(event): void {
    let paymentControlGroup: FormGroup = event.paymentGroup;
    if (event.buttonAction == "CancelPayment") {
      this.step = csSummary;
      this.currentCGL = 0;
      this.payPost = null;
      return;
    }

    // 1). To do collect bill payment information
    // 2). then proceed with processBillPayment returns auth code & sends email to group admin (if cash pay)
    // 3). do payment setup, take from this.chargeList and only services selected to pay from accountPayment

    // Collect bill payment information
    let userInfo = this.loginSvc.GetSessionUserInfo();
    let payTrans = new orderobject();
    payTrans.account_type = this.serviceCharges.to_account_type;
    payTrans.login_user_name = this.loginSvc.GetUserName(userInfo, false);

    payTrans.trans_account = this.serviceCharges.to_trans_account;
    payTrans.account_type = this.serviceCharges.to_account_type;
    //payTrans.customer_contact_name = this.profileContactName;
    //payTrans.customer_company_name = this.profileCompanyName;
    //payTrans.customer_address = this.profileAddress;
    //payTrans.customer_city = this.profileCity;
    //payTrans.customer_state = this.profileState;
    //payTrans.customer_postal_code = this.profilePostalCode;
    //payTrans.customer_province = this.profileProvince;
    //payTrans.customer_country_code = this.profileCountryCode;
    //payTrans.customer_phone = this.profilePhone;
    //payTrans.customer_email = this.profileEmail;
    payTrans.customer_currency_code = this.paymentCtrl.properties.defaultCurrency;

    payTrans.sub_total = this.paymentCtrl.properties.subTotal;
    payTrans.other_fees = this.paymentCtrl.properties.otherFees;
    payTrans.total = this.paymentCtrl.properties.grandTotal;
    if (payTrans.PAYMENT_REQUEST == null || payTrans.PAYMENT_REQUEST.length == 0)
      payTrans.PAYMENT_REQUEST = [new paymentrequest()];

    payTrans.PAYMENT_REQUEST[0].transactiontype = "authCaptureTransaction";
    payTrans.PAYMENT_REQUEST[0].paymentmethod = paymentControlGroup.get("paymentMethod").value
    payTrans.PAYMENT_REQUEST[0].cardnumber = paymentControlGroup.get("cardNumber").value;
    payTrans.PAYMENT_REQUEST[0].expirationdate = paymentControlGroup.get("cardExpires").value;
    payTrans.PAYMENT_REQUEST[0].cardcode = paymentControlGroup.get("cardCode").value;
    payTrans.PAYMENT_REQUEST[0].invoicenumber = "";
    payTrans.PAYMENT_REQUEST[0].invoicedescription = "Services rendered";

    let ent = this.payPost.ENTS.length > 0 ? this.payPost.ENTS[0] : null;
    if (ent == null) {
      ent = new entity();
      ent.entity_key = Iceutility.guid(true);
      this.payPost.ENTS.push(ent);
    }

    let actHolder = payTrans.PAYMENT_REQUEST[0].paymentmethod == "0" ? this.serviceCharges.bill_to : paymentControlGroup.get("cardHolder").value;

    if (this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actPatient || this.serviceCharges.to_account_type == IceTypes.ACCOUNT_TYPE.actSubscriber) {
      let first = "", last = "";
      let parts = actHolder.split(" ");
      if (parts.length > 0)
        first = parts[0];

      if (parts.length > 1)
        last = parts[1];

      payTrans.PAYMENT_REQUEST[0].firstname = first;
      payTrans.PAYMENT_REQUEST[0].lastname = last;
      this.payPost.entity_key = ent.entity_key;
      ent.first_name = first;
      ent.last_name = last;
      ent.entity_identifier_code = IceTypes.entity_type_qualifier.etqPerson;
    }
    else {
      payTrans.PAYMENT_REQUEST[0].nameonaccount = actHolder;
      this.payPost.entity_key = ent.entity_key;
      ent.organization_name = actHolder;
      ent.entity_identifier_code = IceTypes.entity_type_qualifier.etqNonPerson;
    }

    payTrans.PAYMENT_REQUEST[0].bankaccounttype = paymentControlGroup.get("bankAccountType").value;
    payTrans.PAYMENT_REQUEST[0].bankname = paymentControlGroup.get("bankName").value;
    payTrans.PAYMENT_REQUEST[0].bankroutingnumber = paymentControlGroup.get("bankRoutingNumber").value;
    payTrans.PAYMENT_REQUEST[0].bankaccountnumber = paymentControlGroup.get("bankAccountNumber").value;
    payTrans.PAYMENT_REQUEST[0].nameonaccount = paymentControlGroup.get("bankAccountHolder").value;

    let opts: licenseobject[] = this.paymentCtrl.getOptions();
    for (let iLic = 0; iLic < opts.length; iLic++) {
      let licObj: licenseobject = opts[iLic];
      if (licObj == null) continue;

      // lic condition
      if (licObj.license_id != 1) {
        // remove from payment posting because user deselected this one
        let sub: subscriptionobject = <subscriptionobject>licObj;
        this.payPost.SERVICES = this.payPost.SERVICES.filter(s => s.medical_service_key != sub.subscription_key);
      }
      else if (licObj.license_id == 1) {
        // add to payment transaction
        let svcPayDtl: orderdetailobject = new orderdetailobject();
        svcPayDtl.trans_account = this.serviceCharges.to_trans_account;
        svcPayDtl.account_type = this.serviceCharges.to_account_type;
        svcPayDtl.quantity = 1.0;
        svcPayDtl.price = licObj.rate;
        svcPayDtl.summary = licObj.title;

        let sub: subscriptionobject = <subscriptionobject>licObj;
        svcPayDtl.SUBSCRIPTOBJ.push(sub);
        payTrans.ORDER_DETAILS.push(svcPayDtl);
      }
    }

  //  paymentSection.setLoading(true);
  //  paymentSection.setShow(false);

    this.acctSvc.processBillPayment(this.appSvc.getCurrentAccount(),
      this.appSvc.getCurrentAccountType(),
      payTrans).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let ordObj: orderobject = data[0];
            if (ordObj == null) return;
            // get auth code info
            let transRes = null;
            if (transRes == null) {
              try {
                transRes = JSON.parse(ordObj.payment_response);
              }
              catch (e) {
                console.log(e);
              }
            }

            this.payPost.reference_num = transRes != null && transRes.transactionResponse != null ? transRes.transactionResponse.authCode : "";
            this.payPost.total_paid = this.paymentCtrl.properties.grandTotal;
            this.payPost.cash_coa_type = payTrans.PAYMENT_REQUEST[0].paymentmethod == "0" ? IceTypes.coa_types.coaCashPetty : IceTypes.coa_types.coaCashPrimary;

            if (event.dateOfPaymentSettings != null) {
              let dtCtrl: IcecontrolSettings = <IcecontrolSettings>event.dateOfPaymentSettings;
              let dt = dtCtrl.getFormControl().value;
              if (dt != null)
                this.payPost.pay_date = Iceutility.convertToUTCEx(dtCtrl.getFormControl().value);
            }

            // Reset licenses
            this.paymentCtrl.properties.subTotal = 0.0;
            this.paymentCtrl.properties.otherFees = 0.0;
            this.paymentCtrl.properties.grandTotal = 0.0;
            this.paymentCtrl.properties.lastErrors = null;
            for (let iLic = 0; iLic < opts.length; iLic++) {
              let licObj: licenseobject = opts[iLic];
              if (licObj == null) continue;

              licObj.license_id = -1;
            }

            this.acctSvc.postPayment(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.payPost).subscribe(
              data => {
                this.step = csSummary;
                this.currentCGL = 0;
                if (data != null && data.length > 0) {                  
                  let processedPayment: payment = data[0];
                  for (let isvc = 0; isvc < processedPayment.SERVICES.length; isvc++) {
                    let svc = processedPayment.SERVICES[isvc];
                    // remove processed payments
                    let postdata = this.currentChargeHistory.getAllServicePostings(svc.medical_service_key);
                    if (postdata != null) {
                      for (const postkey in postdata) {
                        let thispost: payment = postdata[postkey];
                        if (thispost == null) continue;

                        let keepSvcs = thispost.SERVICES.filter(x => x.service_reference_key != svc.service_reference_key);
                        let noOfSvcChanged = thispost.SERVICES.length != keepSvcs.length;
                        if (noOfSvcChanged) {
                          // remove the service from processing
                          thispost.SERVICES = keepSvcs;
                        }

                        if (noOfSvcChanged && thispost.SERVICES.length == 0) {
                          // all done remove the posting from processing
                          postdata[postkey] = null;
                        }
                      }
                    }

                    this.currentChargeHistory.setServicePosting(svc.medical_service_key, processedPayment.payment_key, processedPayment);
                    this.currentChargeHistory.setServiceAmountDue(svc.medical_service_key, 0.0);
                    this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, svc.medical_service_key, IceTypes.coa_types.coaDeductibleAR).subscribe(
                      data => {
                        let charge = null;
                        let foundSvc = this.chargeList.filter(c => c.medical_service_key == svc.medical_service_key);
                        if (foundSvc.length > 0) {
                          charge = foundSvc[0];
                        }
                        else {
                          console.log("");
                          return;
                        }
                       
                        if (data != null) {
                          this.currentChargeHistory.setServiceAssets(charge.medical_service_key, data);
                          let credit = 0.0;
                          for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
                            let jrnl: assetjournal = data[ijrnl];
                            let coatyp = Iceutility.toLong(jrnl.coa_type)
                            if (coatyp == IceTypes.coa_types.coaAR
                              || coatyp == IceTypes.coa_types.coaCoPayAR
                              || coatyp == IceTypes.coa_types.coaCoInsuranceAR
                              || coatyp == IceTypes.coa_types.coaDeductibleAR)
                              credit += Iceutility.toDouble(jrnl.credit);
                          }
                          let ctrl: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
                          let frmCtrl = ctrl.getFormControl();
                          frmCtrl.setValue(Iceutility.toDouble(charge.total_amount) - credit);
                          ctrl.properties.color = frmCtrl.value > 0 ? "red" : "green";

                          // Clear pay amount
                          let ctrlPaid: IcecontrolSettings = <IcecontrolSettings>this.amountPaid[charge.medical_service_key];
                          let frmCtrlPaid = ctrlPaid.getFormControl();
                          frmCtrlPaid.setValue(0);

                          this.currentChargeHistory.setServiceAmountDue(charge.medical_service_key, frmCtrl.value);
                        }
                      },
                      error => {
                        console.log(error);
                      });

                  }
                  setTimeout(() => {
                    this.totalDue = 0.0;
                    this.initializePartyBuckets(null, null);
                    for (let ichrg = 0; ichrg < this.chargeList.length; ichrg++) {
                      let charge = this.chargeList[ichrg];
                      let partyBucketKey = AccountingService.getPartyBucketKey(charge);
                      let ctrlDue: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
                      let frmCtrlDue = ctrlDue.getFormControl();
                      if (frmCtrlDue) {
                        this.partyBuckets[partyBucketKey]["amount_due"] += Iceutility.toDouble(frmCtrlDue.value);
                        this.totalDue += Iceutility.toDouble(frmCtrlDue.value);
                      }
                    }
                  }, 1000);
                }
                //this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
              },
              error => {
                console.log(error);
              });
          }
        },
        error => {
          console.log(error);
          //      paymentSection.setLoading(false);
          //      paymentSection.setShow(true);

          // First lets do the basic error then try the full object
          let msg = "";
          if (error.statusText != null)
            msg += error.statusText;

          if (error.status != null)
            msg += " (" + error.status + ").";

          msg += "Make sure to complete the payment information using first and last name, and bank card or account information."
          this.acctSvc.logMessage(IceTypes.LOGTYPE.ltError, msg);

          var logrpt = new LogReport();
          var logmsg = new logmessage();
          logmsg.logtype = IceTypes.LOGTYPE.ltError;
          logmsg.message = msg;
          logrpt.LOGS.push(logmsg);
          var logrpts = [logrpt];

          this.paymentCtrl.properties.lastErrors = {
            requestUrl: null,
            logReports: logrpts,
            genericErrors: null
          };

          let errObj = this.acctSvc.getLastErrors();
          if (errObj != null && errObj.logReports != null) {
            try {
              console.log(JSON.stringify(errObj));
              this.paymentCtrl.properties.lastErrors = errObj;
            }
            catch (loge) {
              // fall through
            }
          }
        });
  }

  // Summary Getters
  getCurrentDate(): string {
    return Iceutility.getDateTextEx(Iceutility.GetLocalDate(), null, true);
  }

  getSummaryBillStatus(): string {
    return MessageService.getStatus(Iceutility.toLong(this.serviceCharges.bill_status));
  }

  getServiceDates(charge: medicalservice): string {
    if (charge == null || charge.SVCDTS.length == 0)
      return "";


    let dtFrom = Iceutility.isTextDateTime(charge.SVCDTS[0].date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].date_required), null, false);
    let dtTo = Iceutility.isTextDateTime(charge.SVCDTS[0].end_date_required) ? Iceutility.getDateTextEx(charge.SVCDTS[0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(charge.SVCDTS[0].end_date_required), null, false);
    return dtFrom + " - " + dtTo;
  }

  getServiceCode(charge: medicalservice): string {
    if (charge == null)
      return "";

    return charge.code;
  }

  getServiceDescription(charge: medicalservice): string {
    if (charge == null)
      return "";

    return charge.service_description;
  }

  getServiceAdditionalNote(charge: medicalservice): string {
    if (charge == null)
      return "";

    return charge.additional_note;
  }

  getServiceAmountDue(charge: medicalservice): string {
    if (charge == null)
      return "0";

    let ctrl: IcecontrolSettings = <IcecontrolSettings>this.amountDue[charge.medical_service_key];
    let frmCtrl = ctrl.getFormControl();
    if (frmCtrl == null) return "0";

    return frmCtrl.value.toString();
  }

  getServiceAmountPaid(charge: medicalservice): string {
    if (charge == null || this.payPost == null)
      return "0";

    let foundOrdSvc = this.payPost.SERVICES.filter(s => s.medical_service_key == charge.medical_service_key);
    if (foundOrdSvc.length == 0) return "0";

    return foundOrdSvc[0].amount.toString();
  }

  getServiceBillTo(charge: medicalservice): string {
    let ctrl: IcecontrolSettings = <IcecontrolSettings>this.billTo[charge.medical_service_key];
    let frmCtrl = ctrl.getFormControl();
    if (frmCtrl == null) return "";
    let foundBillTo = ctrl.getOptions().filter(o => o.value == frmCtrl.value);
    if (foundBillTo.length == 0) return "";

    return foundBillTo[0].name;
  }

  getSummaryTotalTax(): string {
    return Iceutility.toDouble(this.totalTax).toString();
  }

  getSummaryTotalDue(): string {
    return Iceutility.toDouble(this.totalDue).toString();
  }

  getSummaryTotalPaidAmount(): string {
    return this.payPost == null ? "0" : this.payPost.total_paid.toString();
  }

  getSummaryRemainingBalance(): string {
    return this.payPost == null ? Iceutility.toDouble(this.totalDue).toString() : (Iceutility.toDouble(this.totalDue) - Iceutility.toDouble(this.payPost.total_paid)).toString();
  }

}
